import AliYunIATSpeechRecognitionService from "./AliYunIATSpeechRecognitionService";
import AliYunIntIATSpeechRecognitionService from "./AliYunIntIATSpeechRecognitionService";
import XunFeiASRSpeechRecognitionService from "./XunFeiASRSpeechRecognitionService";
import XunFeiIATSpeechRecognitionService from "./XunFeiIATSpeechRecognitionService";
import AzureIATSpeechRecognitionService from "./AzureIATSpeechRecognitionService";
import AzureSpeechRecognitionService from "./AzureSpeechRecognitionService";
import XunFeiSpeechRecognitionService from "./XunFeiSpeechRecognitionService";
import SingSoundSpeechRecognitionService from "./SingSoundSpeechRecognitionService";

const serviceType = {
    XunFeiASR: 0,
    XunFeiIAT: 1,
    AliYunIAT: 2,
    AliYunIntIAT: 3,
    AzureIAT: 4,
};
const reviewServiceType = {
    Azure: 0,
    XunFei: 1,
    SingSound: 2,
};
export default class SpeechServiceFactory {
    speechRecognitionService;

    constructor(forReview, type, configMap) {
        if (!forReview) {
            switch (type) {
                case serviceType.XunFeiASR:
                    this.speechRecognitionService = new XunFeiASRSpeechRecognitionService(configMap);
                    break;
                case serviceType.XunFeiIAT:
                    this.speechRecognitionService = new XunFeiIATSpeechRecognitionService(configMap);
                    break;
                case serviceType.AliYunIAT:
                default:
                    this.speechRecognitionService = new AliYunIATSpeechRecognitionService(configMap);
                    break;
                case serviceType.AliYunIntIAT:
                    this.speechRecognitionService = new AliYunIntIATSpeechRecognitionService(configMap);
                    break;
                case serviceType.AzureIAT:
                    this.speechRecognitionService = new AzureIATSpeechRecognitionService(configMap);
                    break;
            }
        } else {
            switch (type) {
                case reviewServiceType.Azure:
                default:
                    this.speechRecognitionService = new AzureSpeechRecognitionService(configMap);
                    break;
                case reviewServiceType.XunFei:
                    this.speechRecognitionService = new XunFeiSpeechRecognitionService(configMap);
                    break;
                case reviewServiceType.SingSound:
                    this.speechRecognitionService = new SingSoundSpeechRecognitionService(configMap);
                    break;
            }
        }
    }

    Recognize(referenceText, wav, callback) {
        this.speechRecognitionService.Recognize(referenceText, wav, callback);
    }

    BeforeSendVoiceData(referenceText, callback) {
        this.speechRecognitionService.BeforeSendVoiceData(referenceText, callback);
    }

    SendVoiceData(voiceData, offset, length) {
        this.speechRecognitionService.SendVoiceData(voiceData, offset, length);
    }

    AfterSendVoiceData(wav) {
        this.speechRecognitionService.AfterSendVoiceData(wav);
    }

    IsErrorWhenSendingStream() {
        this.speechRecognitionService.IsErrorWhenSendingStream();
    }

    getNeedSendWavHeaderInNetworkStream() {
        return this.speechRecognitionService.getIsSpeechEvaluation();
    }

    getIsSpeechEvaluation() {
        return this.speechRecognitionService.getIsSpeechEvaluation();
    }

    destroy() {
        this.speechRecognitionService.destroy();
    }
}
